import React, {useCallback, useMemo, useState} from "react";
import {useRequest} from "../../../utils/hooks.jsx";
import {TableDateRangeTable} from "../../../components/OrdersDateRangeTable/TableDateRangeTable.jsx";
import {adminVendorsColumns, providerTableColumns} from "../../../admin/AdminVendors/AdminVendorsColumns.jsx";
import {defaultPageSizeSystemProvider} from "./consts.js";
import "./system-providers.css";

export const SystemProviders = () => {
    const [searchInput, setSearchInput] = useState("");
    const [pagination, setPagination] = useState({page: 1, itemsInPage: defaultPageSizeSystemProvider});

    const requestURI = useMemo(() => {
        const params = new URLSearchParams();
        if (searchInput) {
            params.append("search", searchInput);
        }
        params.append("page", pagination.page);
        params.append("pageSize", pagination.itemsInPage);
        params.append("includeUserData", true);
        return `/api/system/providers?${params.toString()}`;
    }, [searchInput, pagination.page, pagination.itemsInPage]);

    const [response = {}, isLoading] = useRequest(
        requestURI,
        "POST",
        {
            projection: {
                provider: [
                    "providerId",
                    "contactPhoneNumber",
                    "businessName",
                    "contactEmail",
                    "imageUrl",
                    "approved",
                    "address",
                    "kosher",
                    "brandNames",
                    "kosherCertificateImageUrl"
                ],
                product: ["productId", "isActive"]
            },
            filterOptions: {
                product: {
                    isActive: true
                }
            }
        },
        [requestURI],
        pagination?.page && pagination?.itemsInPage
    );

    const onSearchInput = useCallback(text => {
        setSearchInput(text);
        setPagination(prev => ({page: 1, itemsInPage: defaultPageSizeSystemProvider}));
    }, []);

    return (
        <div className="system-providers-page">
            <TableDateRangeTable
                data={response?.providers ?? []}
                isLoadingOrderTable={isLoading}
                columns={adminVendorsColumns()}
                onInputSearch={setSearchInput}
                pagination={{
                    position: ["bottomRight"],
                    showSizeChanger: false,
                    defaultPageSize: defaultPageSizeSystemProvider,
                    showTotal: total => <span>סה״כ {total}</span>,
                    current: pagination?.page,
                    pageSize: pagination?.itemsInPage,
                    total: response?.totalProviders ?? 0,
                    onChange: (page, pageSize) => setPagination({page, itemsInPage: pageSize})
                }}
                hideDatesPicker={true}
                showSearchByCreatedAt={false}
                hideColumns={[
                    providerTableColumns.createdAt,
                    providerTableColumns.arrearsDebt,
                    providerTableColumns.futureDebt,
                    providerTableColumns.netPaymentTerms,
                    providerTableColumns.sumOfFutureDebtAndArrearsDebt,
                    providerTableColumns.actions
                ]}
            />
        </div>
    );
};
